/**
 * This function receive an array of image objects from detail request and return an object of images for
 * the edit form.
 */
const parseStoryImagesToFormValues = async storyImages => {
  const images = {};

  for (let i = 1; i <= 5; i++) {
    const image = storyImages[i - 1];
    if (image) {
      const blob = await fetch(image.imageUrl).then(r => r.blob())
      blob.name = decodeURIComponent(image.imageUrl.split('/').pop())
      images[`image${i}`] = blob;
      images[`image${i}Description`] = image.imageDescription;
    } else {
      images[`image${i}`] = null;
      images[`image${i}Description`] = '';
    }
  }

  return images;
}

export default parseStoryImagesToFormValues;
